import { getRequest } from "../../utils/apiHelper";
import { setLoading, setError, setProfile } from "./settingsSlice";

export const fetchEmployeeDataAPI = (employeeId) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await getRequest(
      `api/Employee/GetEmployeeById?id=${employeeId}`
    );

    if (response.data) {
      dispatch(setProfile(response.data));
    } else {
      dispatch(setError("No profile data found."));
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.Message ||
      error.message ||
      "Failed to fetch employee data.";
    dispatch(setError(errorMessage));
    console.error("API Error - fetchEmployeeDataAPI:", errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
};
